import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Card, Col, Row } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import '../../../../styles/pages/busk/components/_settlement-detail.scss';
import { dateFormat } from '../../utils/date';
import { status } from '../../utils/status';
import settlement from '../services/settlement';
import { ITransactionDetail } from '../types/settlement.interface';

const TransactionDetail = () => {
  const [transaction, setTransaction] = useState<ITransactionDetail | null>(
    null
  );
  const { id }: any = useParams();
  const breadcrumbList = [
    {
      tittle: '정산 관리',
      url: '/admin/busk/settlement'
    },
    {
      tittle: '정산 진행상황 조회',
      url: '/admin/busk/settlement'
    },
    {
      tittle: '거래 상세',
      url: ''
    }
  ];

  const getTransitionDetail = useCallback(async () => {
    const res = await settlement.getTransactionDetail(id);
    const billingStatus = status(res?.data?.billingStatus);
    setTransaction({
      ...res?.data,
      status: billingStatus,
      start: dateFormat(res?.data?.periodStart),
      end: dateFormat(res?.data?.periodEnd)
    });
  }, [id]);

  useEffect(() => {
    getTransitionDetail();
  }, [getTransitionDetail]);

  const onDownload = () => {
    if (transaction?.billingInquiryFile?.url)
      window.open(transaction.billingInquiryFile.url, '_blank', 'noopener');
  };

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="settlement-detail">
        <Row gutter={[16, 16]}>
          <Col xs={24} lg={8} className="settlement-info-left">
            <Card bordered={false}>
              <div className="label">
                <p>판매자 사업자명</p>
                <p>거래 물류센터명</p>
                <p>영수증 번호</p>
              </div>
              <div className="value">
                <p>{transaction?.seller?.name}</p>
                <p>{transaction?.warehouse?.name}</p>
                <p>{transaction?.receiptId}</p>
              </div>
            </Card>
          </Col>
          <Col xs={24} lg={16} className="settlement-info-right">
            <Card bordered={false}>
              <div className="settlement-info-right-item">
                <p className="item-title">From.</p>
                <p>
                  <span className="item-name">
                    {transaction?.warehouse?.name}
                  </span>
                  <span className="item-country">
                    {transaction?.warehouse?.country}
                  </span>
                </p>
                <p className="item-phone">
                  <span className="label">Tel</span>{' '}
                  {`${transaction?.warehouse?.countryCode ?? ''} ${
                    transaction?.warehouse?.phoneNumber ?? ''
                  }`}
                </p>
                <p className="item-mail">
                  <span className="label">Email</span>{' '}
                  {transaction?.warehouse?.email}
                </p>
                <p className="address">
                  {transaction?.warehouse?.detailAddress}
                </p>
                <p></p>
              </div>
              <div className="settlement-info-right-item">
                <p className="item-title">To.</p>
                <p>
                  <span className="item-name">{transaction?.seller?.name}</span>
                  <span className="item-country">
                    {transaction?.seller?.country}
                  </span>
                </p>
                <p className="item-phone">
                  <span className="label">Tel</span>{' '}
                  {`${transaction?.seller?.countryCode ?? ''} ${
                    transaction?.seller?.phoneNumber ?? ''
                  }`}
                </p>
                <p className="item-mail">
                  <span className="label">Email</span>{' '}
                  {transaction?.seller?.email}
                </p>
                <p className="address">{transaction?.seller?.detailAddress}</p>
              </div>
            </Card>
          </Col>
          <Col span={24}>
            <Card className="section-content-layout" bordered={false}>
              <div className="settlement-status">
                <div
                  className={
                    'settlement-status-content' +
                    (transaction?.billingStatus === 'Request'
                      ? ' request'
                      : transaction?.billingStatus === 'Completed'
                      ? ' completed'
                      : '')
                  }
                >
                  {transaction?.status}
                </div>
              </div>
              <div className="section-content">
                <div className="section-content-header">
                  <div className="label">서비스 이용 내역</div>
                  <div>
                    {transaction?.start} ~ {transaction?.end}
                  </div>
                </div>
                <Row gutter={0} className="section-content-body">
                  <Col xs={6} className="item-label">
                    물류센터 입고 상품 종류
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {transaction?.numberProductTypes ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label">
                    총 주문 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">{transaction?.orderCounts ?? 0}</div>
                  </Col>
                  <Col span={24} className="sub-title">
                    입고 내역
                  </Col>
                  <Col xs={6} className="item-label">
                    물류센터 입고 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {transaction?.numberDelivered ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label">
                    판매자 반송 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {transaction?.numberReturn ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label">
                    폐기 상품 개수
                  </Col>
                  <Col xs={18} className="item-value">
                    <hr className="dotted" />
                    <div className="value">
                      {transaction?.numberDisposal ?? 0}
                    </div>
                  </Col>
                  <Col xs={6} className="item-label-total">
                    총 결제 금액
                  </Col>
                  <Col xs={18} className="item-value-total">
                    <hr className="dotted" />
                    <div className="value">
                      {`US$ ${transaction?.billingAmount ?? 0}`}
                    </div>
                  </Col>
                </Row>
                <div className="section-content-footer">
                  <Button className="btn-download" onClick={onDownload}>
                    거래 명세서 다운로드
                  </Button>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TransactionDetail;
